import { render, staticRenderFns } from "./ProgramModuleList.vue?vue&type=template&id=526f8d84&scoped=true"
import script from "./ProgramModuleList.vue?vue&type=script&lang=js"
export * from "./ProgramModuleList.vue?vue&type=script&lang=js"
import style0 from "./ProgramModuleList.vue?vue&type=style&index=0&id=526f8d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f8d84",
  null
  
)

export default component.exports